
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function SpecsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  const specs = [
    { label: 'Flame Type', value: 'Jet Torch' },
    { label: 'Ignition', value: 'Piezoelectric' },
    { label: 'Fuel', value: 'Butane Gas' },
    { label: 'Capacity', value: '3 Cigarettes' },
    { label: 'Ignitions per Refill', value: '10+ Ignitions' },
    { label: 'Material', value: 'Zinc Alloy' },
    { label: 'Wind Resistance', value: 'Up to 40 mph (64 km/h)' },
    { label: 'Design', value: 'Tactical Pistol Style' },
    { label: 'Note', value: 'Shipped without fuel (safety)' },
  ];

  return (
    <section id="specs" ref={ref} className="py-12 sm:py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-6 sm:mb-10 md:mb-16"
        >
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-black mb-2 sm:mb-4">
            Technical Specifications
          </h2>
          <p className="text-black/60 text-xs sm:text-sm md:text-base lg:text-lg">
            Precision engineering in every detail.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="border border-black/10 rounded-lg overflow-hidden"
        >
          {specs.map((spec, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className={`flex flex-col sm:flex-row sm:items-center justify-between gap-0.5 sm:gap-4 p-3 sm:p-4 md:p-5 lg:p-6 ${
                index !== specs.length - 1 ? 'border-b border-black/10' : ''
              }`}
            >
              <div className="font-medium text-black/60 text-[11px] sm:text-xs md:text-sm lg:text-base">
                {spec.label}
              </div>
              <div className="font-serif text-black text-xs sm:text-sm md:text-base lg:text-lg sm:text-right">
                {spec.value}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
